module.exports = __webpack_public_path__ + "img/moon.5e09532c.svg";